@if ({ isTop: isTopNav$ | async }; as navigation) {
    @if (showHeader()) {
        <header [ngClass]="{ 'header--top-nav-transparent-sticky': isTopNavTransparentSticky }" class="header">
            <a
                (click)="goToMain('main-content')"
                [core-analytics]="{ action: 'Skip to main content', category: 'HEADER' }"
                class="skip-to-content visually-hidden-focusable"
                href="javascript:void(0)">
                <span class="skip-to-content__link">Skip to main content</span>
            </a>
            @if (!navigation.isTop) {
                <core-side-nav></core-side-nav>
            }
            @if (navigation.isTop) {
                @if (isDesktopHeader() && canShowUtilitiesAbove) {
                    <core-top-nav-utilities position="above"></core-top-nav-utilities>
                }

                @if (isInlineLogoAndNav) {
                    <core-top-navigation-inline></core-top-navigation-inline>
                } @else {
                    <core-top-navigation></core-top-navigation>
                }

                @if (isDesktopHeader() && canShowUtilitiesBelow) {
                    <core-top-nav-utilities position="below"></core-top-nav-utilities>
                }
            }
        </header>
    }
}
